export const ORDERS_PREFIX = 'orders';
const REPORTS_PREFIX = 'reports';

type OrderViewNestedPathLiterals = 'orders' | 'attachments';

export const PATH_NAMES = {
  ROOT: '/',
  auth: {
    LOGIN: '/login',
    LOGOUT: '/logout',
    OAUTH_VERIFY: '/oauth/verify',
  },
  order: {
    view: (orderGuid: string, nestedPath?: OrderViewNestedPathLiterals) =>
      ['', ...[ORDERS_PREFIX, orderGuid], ...(nestedPath ? [nestedPath] : [])].join('/'),
  },
  orderListView: {
    SUBMITTED: `/${ORDERS_PREFIX}/submitted`,
    ON_HOLD: `/${ORDERS_PREFIX}/on-hold`,
    SCHEDULED: `/${ORDERS_PREFIX}/scheduled`,
    DELIVERED: `/${ORDERS_PREFIX}/delivered`,
    PICKED_UP: `/${ORDERS_PREFIX}/picked-up`,
    CANCELED: `/${ORDERS_PREFIX}/canceled`,
  },
  ANALYTICS: '/analytics',
  reports: {
    VIEW: `/${REPORTS_PREFIX}/view`,
  },
};
